import React, { Component } from "react";

// columns: array
// sortColumn: object
// onSort: function

class STableHeader extends Component {
  raiseSort = path => {
    const sortColumn = { ...this.props.sortColumn };
    if (path !== "idx" && path !== "action") {
      if (sortColumn.path === path)
        sortColumn.order = sortColumn.order === "asc" ? "desc" : "asc";
      else {
        sortColumn.path = path;
        sortColumn.order = "asc";
      }
      this.props.onSort(sortColumn);
    }
  };

  renderSortIcon = column => {
    const { sortColumn } = this.props;

    if (column.path !== sortColumn.path) return null;
    if (sortColumn.order === "asc") return <i className="fa fa-sort-asc" />;
    return <i className="fa fa-sort-desc" />;
  };
  getClasses(index, column) {
    let classes = "";
    if (index > 0 && column.path !== "action") classes += "clickable";
    if (column.path === "action" || index === 0) classes += " actionHeader";
    return classes;
  }
  render() {
    return (
      <thead>
        <tr>
          {this.props.columns.map((column, index) => (
            <th
              className={this.getClasses(index, column)}
              key={column.path || column.key}
              onClick={() => this.raiseSort(column.path)}
              style={{
                textAlign: column.textAlign ? column.textAlign : "left"
              }}
            >
              {column.label} {this.renderSortIcon(column)}
            </th>
          ))}
        </tr>
      </thead>
    );
  }
}

export default STableHeader;



// WEBPACK FOOTER //
// ./src/components/Common/STableHeader.jsx